import React, { Suspense, lazy, useEffect } from "react";
import ReactDOM from "react-dom";
import createTheme from "@material-ui/core/styles/createTheme";
import ThemeProvider from "@material-ui/styles/ThemeProvider";
import Ui from "@micado-digital/react-ui/components/Ui";
import { theme as customTheme } from "./themes/project";

const ReactTourismRatingSurvey01 = lazy(() =>
	import(
		/* webpackChunkName: "reactTourismRating01" */ "@micado-digital/react-tourism-rating-survey/ReactTourismRatingSurvey01"
	)
);
const ReactTourismRatingReviews = lazy(() =>
	import(
		/* webpackChunkName: "reactTourismRating01" */ "@micado-digital/react-tourism-rating-reviews/ReactTourismRatingReviews"
	)
);
const ReactTourismRatingSeal01 = lazy(() =>
	import(
		/* webpackChunkName: "reactTourismRatingSeal01" */ "@micado-digital/react-tourism-rating-seal/ReactTourismRatingSeal01"
	)
);

const theme = createTheme(customTheme);

const App = () => {
	const { REACT_APP_PATH } = process.env;

	useEffect(() => {
		const replaceRatingSeal = () => {
			const $ratingSeal = document.querySelector(".mco-tourism-rating-seal");
			const $surveySeal = document.querySelector(".mco-tourism-rating-survey__seal-container");

			if ($ratingSeal && $surveySeal) {
				$surveySeal.replaceWith($ratingSeal);
			} else {
				setTimeout(replaceRatingSeal, 100); // Retry after 100ms
			}
		};

		replaceRatingSeal();
	}, []);

	return (
		<ThemeProvider theme={theme}>
			<Suspense fallback={<></>}>
				<Ui>
					<ReactTourismRatingSeal01
						lang={document.documentElement.lang ? document.documentElement.lang : "de"}
						providerID={1}
						url={`${REACT_APP_PATH}/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListRatings.api`}
					/>
					<ReactTourismRatingSurvey01
						headlineCategories={
							document.documentElement.lang === "de"
								? `Bewertungen im Detail`
								: `Reviews in detail`
						}
						lang={document.documentElement.lang}
						surveyID={1}
						url={`${REACT_APP_PATH}/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/GetSurveyDetails.api`}
					/>
					<div style={{ marginTop: 56 }}>
						<ReactTourismRatingReviews
							headline={
								document.documentElement.lang === "de"
									? `Das sagen unsere Gäste`
									: `That's what our guests say`
							}
							lang={document.documentElement.lang}
							pagesize={20}
							providerID={1}
							sortReviews={1} /* 0 Bewertung - 1 Datum */
							url={`${REACT_APP_PATH}/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListRatings.api`}
						/>
					</div>
				</Ui>
			</Suspense>
		</ThemeProvider>
	);
};

ReactDOM.render(<App />, document.getElementById("react-rating"));
